import alt from "../alt";
import indexBy from "lodash/keyBy";
import extend from "lodash/extend";
import values from "lodash/values";
import GiftCardActions from "../actions/GiftCardActions";
import GiftCardUtil from "../utils/GiftCardUtil";
import UserStore from "../stores/UserStore";
import GlobalNotificationActions from "../actions/GlobalNotificationActions";

class GiftCardStore {
  constructor() {
    this.bindActions(GiftCardActions);

    this.state = {
      giftCards: {}
    };
  }

  onFetchAll() {
    this.setState({ isFetching: true });
    GiftCardUtil.fetchAll(UserStore.getState().apiKey)
      .then(data => {
        this.setState({
          isFetching: false,
          giftCards: indexBy(data, "id")
        });
      })
      .catch(GiftCardActions.fetchFailed);
  }

  onCreate(giftCard) {
    this.setState({ isCreating: true });
    GiftCardUtil.create(UserStore.getState().apiKey, giftCard)

      .then(data => {
        this.setState({
          isCreating: false,
          giftCards: extend({}, this.state.giftCards, {
            [data.id]: data
          })
        });
      })
      .catch(GiftCardActions.editFailed);
  }

  onDelete(id) {
    this.setState({ isDeleting: true });
    GiftCardUtil.delete(UserStore.getState().apiKey, id)
      .then(() => {
        let giftCards = this.state.giftCards;
        delete giftCards[id];
        this.setState({
          isDeleting: false,
          giftCards: giftCards
        });
      })
      .catch(GiftCardActions.editFailed);
  }

  onAdjustGiftCard(request) {
    this.setState({ isAdjusting: true });
    GiftCardUtil.adjustGiftCard(UserStore.getState().apiKey, request)
      .then(data => {
        this.setState({
          isAdjusting: false,
          giftCards: extend({}, this.state.giftCards, {
            [data.gift_card.id]: data.gift_card
          })
        });

        GlobalNotificationActions.notify("Gift card adjusted successfully!");
      })
      .catch(GiftCardActions.editFailed);
  }

  onFetchFailed(e) {
    window.alert(`Fetching gift cards failed: ${e.message}`);
  }

  onEditFailed(e) {
    window.alert(`Updating gift card failed: ${e.message}`);
  }
}

export default alt.createStore(GiftCardStore, "GiftCardStore");



// WEBPACK FOOTER //
// ./src/app/stores/GiftCardStore.js